import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Injectable, OnDestroy } from "@angular/core";
import { Subject, takeUntil } from 'rxjs';
@Injectable({
  providedIn: 'root'
})
export class PlanShipmentService implements OnDestroy{
  private url = "api/Shipments";
  private headers = new HttpHeaders({ "Content-Type": "application/json" });
  options = { headers: this.headers };
  private requests$ = new Subject<any>();
  private queue: PendingRequest[] = [];
  private destroy$ = new Subject<void>();
  constructor(private http: HttpClient) { 
    this.requests$.pipe(takeUntil(this.destroy$)).subscribe(request => this.execute(request)); 
  }

  planShip(method, params, options) {
    return this.addRequestToQueue(method, params, options);
  }

  private addRequestToQueue(method, params, options) {
    const sub = new Subject<any>();
    const request = new PendingRequest(method, params, sub);
    this.queue.push(request);    
    if (this.queue.length === 1) {
      this.startNextRequest();
    }
    return sub;
  }

  private startNextRequest() {
    if (this.queue.length > 0) {
      this.execute(this.queue[0]);
    }
  }

  private execute(requestData) {
    const req = this.http.post(`/${this.url}/PlanShip`, requestData.options, this.options).pipe(takeUntil(this.destroy$)).subscribe({
      next: (res) => {
        const sub = requestData.subscription;
        sub.next(res);
        this.removeRequestFromQueue();
      },
     error: (err) => {
      const sub = requestData.subscription;
      const error = {
        shipmentPlans: [],
        errors: [{
          reason: 'Error getting results',
          code: err.status,
        }]
      }
      sub.next(error);
      this.removeRequestFromQueue();
     }
   });
  }  

  removeRequestFromQueue() {
    this.queue.shift();
    this.startNextRequest();
  }
  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.unsubscribe();
  }
}

export class PendingRequest {
  url: string;
  method: string;
  options: any;
  subscription: Subject<any>;

  constructor(method: string, options: any, subscription: Subject<any>) {
    this.method = method;
    this.options = options;
    this.subscription = subscription;
  }
}
